import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import type {
  ProfilePropertiesRequest,
  RiskProfilePropertiesResponse,
} from '../types/riskProfileProperties.types'

export const PROFILE_SOCIAL_ECONOMIC_QUERY_KEY = 'risk-profile-social-economic'

export const fetchProfileRiskSocialEconomic = async (
  request: ProfilePropertiesRequest,
): Promise<RiskProfilePropertiesResponse> => {
  const { data } = await apiClient.post<RiskProfilePropertiesResponse>(
    Endpoint.riskProfileProperties,
    request,
  )
  return data
}
